<template>
	<v-main v-if="$route.query.body !== '0'">
		<div class="head-banner bgWhite pb-12 pb-md-0">
			<div class="banner-delimiter d-none d-md-flex">
				<v-item-group
					v-model="banner"
					class="shrink my-auto ml-6"
					mandatory
				>
					<v-item
						v-for="n in banners.length || 0"
						:key="n"
						v-slot="{ active, toggle }"
					>
						<div>
							<v-btn
								:input-value="active"
								icon
								@click="toggle"
							>
								<v-icon>mdi-record</v-icon>
							</v-btn>
						</div>
					</v-item>
				</v-item-group>
			</div>

			<div class="banner-delimiter mobile d-md-none">
				<v-item-group
					v-model="banner"
					class="shrink text-center"
					mandatory
				>
					<v-item
						v-for="n in banners.length || 0"
						:key="n"
						v-slot="{ active, toggle }"
					>
						<v-btn
							:input-value="active"
							icon
							@click="toggle"
						>
							<v-icon>mdi-record</v-icon>
						</v-btn>
					</v-item>
				</v-item-group>
			</div>

			<v-window
				v-model="banner"
				class="banner-carousel"
				continuous
			>
				<v-window-item
					v-for="(b, i) in banners"
					:key="`banner-${i}`"
					style="height: 100%; max--height: 500px;"
				>
					<a
						v-if="typeof b === 'object'"
						:href="b.href"
						:target="b.target || '_self'"
					>
						<v-img
							:src="b.src"
							max-width="100%"
							height="100%"
							:max--height="500"
							lazy-src
						/>
					</a>
					<v-img
						v-else
						:src="b"
						max-width="100%"
						height="100%"
						:max--height="500"
						lazy-src
					/>
				</v-window-item>
			</v-window>

			<v-btn
				color="#a12028"
				min-width="52"
				class="banner-arrow d-none d-md-flex px-0"
				absolute
				tile
				x-large
				@click="banner = banner - 1 < 0 ? banners.length - 1 : banner - 1"
			>
				<v-icon class="white--text">
					mdi-chevron-left
				</v-icon>
			</v-btn>
			<v-btn
				color="red"
				min-width="52"
				class="banner-arrow d-none d-md-flex px-0"
				absolute
				tile
				x-large
				@click="banner = banner + 1 === banners.length ? 0 : banner + 1"
			>
				<v-icon class="white--text">
					mdi-chevron-right
				</v-icon>
			</v-btn>
		</div>
		<!-- <div style="height: 26vw;">
			<a
				hrefs="https://lin.ee/v9pNnBr"
				target="_blank"
			>
				<v-img
					v-if="$route.query.banner !== '0'"
					src="/images/2.0/home-banner-0000.jpg"
					fetchpriority="high"
					max-width="100%"
					height="100%"
					:max--height="500"
					lazy-src
				/>
			</a>
		</div> -->

		<template v-if="$route.query.search !== '0'">
			<searchForm ref="searchComponent" />
		</template>

		<div class="bgWhite pb-6">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="mx-auto"
					>
						<v-row no-gutters>
							<v-col
								class="flex-grow-0 flex-shrink-1 d-none d-lg-block"
								style="min-width: 30%;"
							>
								<img
									src="/images/2.0/home-001.png"
									fetchpriority="high"
									alt="Your next happiness"
									style="width: 100%;"
								>
							</v-col>

							<v-col class="px-5 py-6 py-lg-0 flex-grow-1 flex-shrink-0 ">
								<div class="mt-7 mt-lg-4 text-center text-lg-left">
									<span style="font-size: 2rem;">
										รวม<span class="red--text">ที่อยู่อาศัย</span>
									</span>
									<p style="font-size: 1.2rem;">
										คุณสามารถเลือกประเภทของอสังหาริมทรัพย์ที่ต้องการ
									</p>
								</div>

								<v-row no-gutters>
									<v-col
										cols="12"
										sm="6"
										md="4"
										class="pa-1"
									>
										<v-btn
											aria-label="Good value property"
											height="auto"
											class="home-cate pl-5 pr-1 py-3"
											block
											tile
											to="/value"
										>
											<!-- <img
												src="/images/2.0/icon/home-1.png"
												alt="บ้านหรูเหนือระดับ"
											> -->
											<div class="home-cate-logo home-cate-1" />
											<div class="text-left ml-3">
												<!-- <span style="font-size: 1.1rem;">บ้านคุ้มค่า</span><br>
												ที่อยู่อาศัย 1-3 ล้านบาท<br> -->
												<span style="font-size: 1.1rem;">ที่อยู่อาศัย</span><br>
												1-3 ล้านบาท<br>
											</div>
											<v-icon
												class="ml-auto"
												x-large
											>
												mdi-chevron-right
											</v-icon>
										</v-btn>
									</v-col>
									<v-col
										cols="12"
										sm="6"
										md="4"
										class="pa-1"
									>
										<v-btn
											aria-label="Promising property"
											height="auto"
											class="home-cate pl-5 pr-1 py-3"
											block
											tile
											to="/promising"
										>
											<!-- <img
												src="/images/2.0/icon/home-1.png"
												alt="บ้านหรูเหนือระดับ"
											> -->
											<div class="home-cate-logo home-cate-2" />
											<div class="text-left ml-3">
												<!-- <span style="font-size: 1.1rem;">บ้านดีมีอนาคต</span><br>
												ที่อยู่อาศัย 3-10 ล้านบาท<br> -->
												<span style="font-size: 1.1rem;">ที่อยู่อาศัย</span><br>
												3-5 ล้านบาท<br>
											</div>
											<v-icon
												class="ml-auto"
												x-large
											>
												mdi-chevron-right
											</v-icon>
										</v-btn>
									</v-col>
									<v-col
										cols="12"
										sm="6"
										md="4"
										class="pa-1"
									>
										<v-btn
											aria-label="Luxury property"
											height="auto"
											class="home-cate pl-5 pr-1 py-3"
											block
											tile
											to="/luxury"
										>
											<!-- <img
												src="/images/2.0/icon/home-1.png"
												alt="บ้านหรูเหนือระดับ"
											> -->
											<div class="home-cate-logo home-cate-3" />
											<div class="text-left ml-3">
												<!-- <span style="font-size: 1.1rem;">บ้านหรูเหนือระดับ</span><br>
												ที่อยู่อาศัย 10 ล้านขึ้นไป<br> -->
												<span style="font-size: 1.1rem;">ที่อยู่อาศัย</span><br>
												5 ล้านขึ้นไป<br>
											</div>
											<v-icon
												class="ml-auto"
												x-large
											>
												mdi-chevron-right
											</v-icon>
										</v-btn>
									</v-col>
									<v-col
										cols="12"
										sm="6"
										md="4"
										class="pa-1"
									>
										<v-btn
											aria-label="Commercial property"
											height="auto"
											class="home-cate pl-5 pr-1 py-3"
											block
											tile
											to="/home-condo"
										>
											<div class="home-cate-logo home-cate-5" />
											<div class="text-left ml-3">
												<span style="font-size: 1.1rem;">คอนโด</span><br>
												ที่อยู่อาศัยแนวสูง<br>
											</div>
											<v-icon
												class="ml-auto"
												x-large
											>
												mdi-chevron-right
											</v-icon>
										</v-btn>
									</v-col>
									<v-col
										cols="12"
										sm="6"
										md="4"
										class="pa-1"
									>
										<v-btn
											aria-label="Commercial property"
											height="auto"
											class="home-cate pl-5 pr-1 py-3"
											block
											tile
											to="/commercial"
										>
											<!-- <img
												src="/images/2.0/icon/home-1.png"
												alt="บ้านหรูเหนือระดับ"
											> -->
											<div class="home-cate-logo home-cate-4" />
											<div class="text-left ml-3">
												<!-- <span style="font-size: 1.1rem;">ทรัพย์สร้างเงิน</span><br>
												อสังหาริมทรัพย์เชิงพาณิชย์<br> -->
												<span style="font-size: 1.1rem;">เชิงพาณิชย์</span><br>
												ทรัพย์เชิงพาณิชย์<br>
											</div>
											<v-icon
												class="ml-auto"
												x-large
											>
												mdi-chevron-right
											</v-icon>
										</v-btn>
									</v-col>
									<v-col
										cols="12"
										sm="6"
										md="4"
										class="pa-1"
									>
										<v-btn
											aria-label="Commercial property"
											height="auto"
											class="home-cate pl-5 pr-1 py-3"
											block
											tile
											to="/land"
										>
											<div class="home-cate-logo home-cate-6" />
											<div class="text-left ml-3">
												<span style="font-size: 1.1rem;">ที่ดิน</span><br>
												ทรัพย์เชิงพาณิชย์<br>
											</div>
											<v-icon
												class="ml-auto"
												x-large
											>
												mdi-chevron-right
											</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row
					class="property-recommend justify-center"
					no-gutters
				>
					<!-- <v-col md="1" /> -->
					<v-col xl="8">
						<h2 class="text-center white--text my-8">
							อสังหาริมทรัพย์แนะนำ
						</h2>

						<propertyCarousel
							v-if="$route.query.recommend !== '0'"
							white
							lists="property/newProps"
							:query="{ path: 'recommend', ipp: $route.query.recommend || 12 }"
						/>

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								aria-label="See more recommend property"
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								to="/recommend"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								aria-label="See more recommend property"
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								to="/recommend"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
					<!-- <v-col md="1" /> -->
				</v-row>
			</v-container>
		</div>

		<div class="bgWhite pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="text-center my-8">
							อสังหาริมทรัพย์<span class="red--text">มาใหม่</span>
						</h2>

						<propertyCarousel
							v-if="$route.query.new !== '0'"
							list="property/newProps"
							:max="parseInt($route.query.new || 12)"
						/>

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								aria-label="See more latest property"
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								to="/latest"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								aria-label="See more latest property"
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								to="/latest"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray py-10">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="mx-auto px-4 px-md-8"
					>
						<h2 class="text-center mb-4">
							รวม<span class="red--text">โครงการ</span>
						</h2>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									aria-label="See more house property"
									height="auto"
									class="property-cate overflow-hidden pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'category-hub-singlehome'}"
								>
									<div class="property-cate-logo singlehome" />
									<div class="text-left ml-1 ml-sm-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									aria-label="See more townhome property"
									height="auto"
									class="property-cate overflow-hidden pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'category-hub-townhome'}"
								>
									<div class="property-cate-logo townhome" />
									<div class="text-left ml-1 ml-sm-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									aria-label="See more condo property"
									height="auto"
									class="property-cate overflow-hidden pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'category-hub-condo'}"
								>
									<div class="property-cate-logo condo" />
									<div class="text-left ml-1 ml-sm-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									aria-label="See more shophouse property"
									height="auto"
									class="property-cate overflow-hidden pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: 'category-hub-shophouse'}"
								>
									<div class="property-cate-logo shophouse" />
									<div class="text-left ml-1 ml-sm-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red bg-black-right">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						offset-xl="2"
					>
						<v-row
							class="bgGray d-flex flex-column flex-md-row-reverse"
							no-gutters
						>
							<v-col
								cols="12"
								md="5"
								class="flex-grow-0 flex-shrink-1 text-right overflow-hidden"
							>
								<img
									class="fill-height"
									src="/images/2.0/home-002.jpg"
									alt="Services"
									style="min-width: 100%;"
								>
							</v-col>

							<v-col
								cols="11"
								md="7"
								class="services bg-red mt-n12 mt-md-0 pa-4 flex-grow-1 flex-shrink-0 white--text"
							>
								<h1>
									SERVICES
								</h1>
								<h2>
									บริการครบจบทุกขั้นตอน
								</h2>
								<h3>
									อยากซื้ออยากขายอสังหาฯปรึกษาเรา
								</h3>
								<v-row
									class="my-3 d-flex"
									no-gutters
								>
									<v-col
										cols="12"
										lg="4"
										class="flex-grow-0 flex-shrink-1"
									>
										<div>
											<v-icon
												color="black"
												class="mr-1"
											>
												mdi-tag
											</v-icon>
											ตั้งราคาแบบมืออาชีพ
										</div>
										<div>
											<v-icon
												color="black"
												class="mr-1"
											>
												mdi-sync
											</v-icon>
											การตลาดครบวงจร
										</div>
										<div>
											<v-icon
												color="black"
												class="mr-1"
											>
												mdi-offer
											</v-icon>
											ฐานผู้ซื้อมีจำนวนมาก
										</div>
									</v-col>
									<v-col
										cols="12"
										lg="8"
										class="flex-grow-1 flex-shrink-0"
									>
										<div>
											<v-icon
												color="black"
												class="mr-1"
											>
												mdi-account-group
											</v-icon>
											มีเครือข่ายตัวแทนช่วยกันขายกว่า 1,000 คน
										</div>
										<div>
											<v-icon
												color="black"
												class="mr-1"
											>
												mdi-home-group
											</v-icon>
											จัดการดูแลเรื่องสินเชื่อ เพื่อบ้านในฝันเป็นจริง
										</div>
										<div>
											<v-icon
												color="black"
												class="mr-1"
											>
												mdi-star
											</v-icon>
											ดูแลการโอนให้จบครบทุกขั้นตอน
										</div>
									</v-col>
								</v-row>

								<div class="mt-4 mt-lg-12 mx-5 mx-md-0 d-flex">
									<v-btn
										aria-label="See more our services"
										class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
										depressed
										tile
										:to="{name: 'service'}"
									>
										บริการของเรา
									</v-btn>
									<v-btn
										aria-label="See more our services"
										class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
										depressed
										tile
										:to="{name: 'service'}"
									>
										<v-icon>
											mdi-arrow-right
										</v-icon>
									</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						offset-xl="2"
					>
						<v-row no-gutters>
							<v-col
								cols="12"
								md="7"
								class="pr-0 pr-md-12 pb-6"
							>
								<h2 class="pt-6 pl-6 pl-md-0 pr-12">
									<span class="red--text">บทความ</span>น่ารู้
								</h2>
								<div class="d-flex align-center mb-4 pl-6 pl-md-0">
									<b>ทำความรู้จักและเข้าใจ “อสังหาริมทรัพย์” กันให้มากขึ้น</b>
									<v-btn
										aria-label="See more articles"
										text
										class="ml-auto d-none d-lg-block pt-2"
										:to="{name: 'blog-tips'}"
									>
										ดูทั้งหมด
										<v-icon
											color="red"
											right
										>
											mdi-arrow-right
										</v-icon>
									</v-btn>
								</div>

								<articleCarousel
									v-if="$route.query.article !== '0'"
									:list="articles"
								/>
							</v-col>

							<v-col
								cols="12"
								md="5"
								class="bg-dark-grey white--text px-0 px-md-8 py-5"
							>
								<h2 class="mb-5 pl-6 pl-md-0">
									ผลงานของเรา
								</h2>
								<portfolioCarousel
									v-if="$route.query.portfolio !== '0'"
									:max="parseInt($route.query.portfolio || 3)"
									white
								/>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>

const doc = 'index'

import { mapActions, mapGetters, mapMutations } from 'vuex'
// import propertyCarousel from '~/components/2.0/property-carousel'
// import articleCarousel from '~/components/2.0/article-carousel'
// import portfolioCarousel from '~/components/2.0/portfolio-carousel'

// import searchForm from '~/components/2.0/search-form-home'

const propertyCarousel = () => import('~/components/2.0/property-carousel.vue').then(m => m.default || m)
const articleCarousel = () => import('~/components/2.0/article-carousel.vue').then(m => m.default || m)
const portfolioCarousel = () => import('~/components/2.0/portfolio-carousel.vue').then(m => m.default || m)

const searchForm = () => import('~/components/2.0/search-form-home.vue').then(m => m.default || m)

export default {
	// scrollToTop: true,
	name: 'INDEX',
	layout: 'default_2',

	components: {
		articleCarousel,
		propertyCarousel,
		portfolioCarousel,
		searchForm,
	},

	async fetch(context) {
		await context.store.dispatch('page/initial', {
			doc: doc,
			fullPath: context.route.fullPath
		})
		await context.store.dispatch('setShowFooter')
	},

	async asyncData(context) {
		if (context.route.query.article === '0') {
			return {
				articles: []
			}
		}

		let articles = await context.app.$fireStore.collection('articles')
			.where('category', '==', 'tips')
			.where('published', '==', true)
			.orderBy('created_at', 'desc')
			.limit(parseInt(context.route.query.article || 3))
			.get()

		return {
			articles: articles.docs.map(item => item.data())
		}
	},

	data() {
		return {
			loading: true,
			keepAliveActivated: false,
			magnify: false,
			message: false,
			radios: false,
			grid: true,

			bannerInterval: null,
			bannerIntervalTime: 3000,
			banner: 0,
			banners: [
				// { src: '/images/2.0/home-banner-006.jpg', href: 'https://lin.ee/v9pNnBr', target: '_blank' },
				// '/images/2.0/home-banner-000.png',
				'/images/2.0/home-banner-0000.jpg',
				'/images/2.0/home-banner-001.jpg',
				// '/images/2.0/home-banner-002.jpg',
				// '/images/2.0/home-banner-003.jpg',
				// '/images/2.0/home-banner-004.jpg',
				// '/images/2.0/home-banner-005.jpg',
				// { src: '/images/2.0/home-banner-008.jpg', href: 'https://lin.ee/v9pNnBr', target: '_blank' },
				// { src: '/images/2.0/home-banner-009.jpg', href: 'https://lin.ee/v9pNnBr', target: '_blank' },
				{ src: '/images/2.0/home-banner-010.jpg', href: 'https://line.me/ti/p/~@thebestproperty', target: '_blank' },
				'/images/2.0/home-banner-011.jpg',
			]
		}
	},

	computed: {
		...mapGetters({
			isMobile: 'isMobile',
			config: 'config',
			head: 'page/head' ,
		}),

		breakpoint () {
			return this.$vuetify.breakpoint.name
		},

		columns () {
			if (this.$vuetify.breakpoint.xl) {
				return 4
			}
			if (this.$vuetify.breakpoint.lg) {
				return 3
			}
			if (this.$vuetify.breakpoint.md) {
				return 2
			}

			return 1
		}
	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			window.scrollTo(0, 0)

			this.loading = true
			this.getPropsForIndex(() => {
				this.loading = false
			})
		}

		// if (this.keepAliveActivated) {
		// Clear search citeria
		if (this.$refs.searchComponent) {
			this.$refs.searchComponent.clearCiteria()
		}
		if (this.isMobile) {
			// Clear mobile search criteria
			if (this.$parent.$parent.$parent.$refs.mobileSearchComponent) {
				this.$parent.$parent.$parent.$refs.mobileSearchComponent.clearCiteria()
			}

			// Clear mobile mini filter
			if (this.$parent.$parent.$parent.$refs.miniFilter) {
				this.$parent.$parent.$parent.$refs.miniFilter.clearCiteria()
			}
		} else {
			if (this.$parent.$parent.$parent.$refs.fullSearchFormAppBar) {
				this.$parent.$parent.$parent.$refs.fullSearchFormAppBar.clearCiteria()
			}
		}

		// if (this.bannerInterval) {
		// 	clearInterval(this.bannerInterval)
		// }
		this.bannerInterval = setInterval(() => {
			this.banner = this.banner + 1 === this.banners.length ? 0 : this.banner + 1
		}, this.bannerIntervalTime)
		// }
	},
	deactivated () {
		// console.log('deactivated')
		// this.$destroy()
		clearInterval(this.bannerInterval)
	},

	created() {
		if (process.client && this.$route.query.data !== '0') {
			// this.loading = true
			this.getPropsForIndex(() => {
				this.keepAliveActivated = true
				this.loading = false
			})
		}
	},

	mounted() {
		this.setHead({
			doc: doc,
			href: window.location.href,
		})
	},

	methods: {
		...mapActions({
			getPropsForIndex: 'property/getPropsForIndex'
		}),

		...mapMutations({
			setHead: 'page/setHead'
		}),
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.banner {
	background: url('~assets/images/room.jpg');
	background-size: cover;
	padding: 80px 0 130px 0;
	text-align: center;
	h1 {
		font-size: 2em;
		text-transform: uppercase;
		color: #fff;
		letter-spacing: 0.1em;
		line-height: 1.4em;
		letter-spacing: 0.5em;
	}
}
.type-link {
	color: #fff;
	text-align: center;
	text-decoration: none;
	margin: 0 6px 0 6px;

	i {
		color: #fff;
		display: block;
	}
}
.locationList { background: rgb(230, 230, 230); padding: 30px 0;
	.listLocation {
		a { position: relative; display: block; }
		img { position: relative; z-index: 1; }
		section { position: absolute; left: 0; right: 0; top: 0; bottom: 0; z-index: 3; background: #333; opacity: 0.4; }
		p { position: absolute; background: #333; color: #fff; left: 25%; right: 25%; top: 50%; border-radius: 4px; text-align: center; display: inline-block; z-index: 4; padding: 5px 0; }
	}
}
.review { background: url('/images/condo.jpg'); background-position: center; background-size: cover; position: relative;
	.overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: #c20000; width: 100%; height: 100%; opacity: 0.2; z-index: 1; }
	.details { position: relative; z-index: 2; background: rgba(255, 255, 255, 0.7); padding: 35px 30px; }
	.featureImage { width: 100%; height: 250px;
		img { object-fit: cover; height: 100%; width: 100%; }
	}
	.listImage { width: 100%; height: 140px;
		img { object-fit: cover; height: 100%; width: 100%; }
	}
	a { color: #333; text-decoration: none; }
	h1 { font-size: 1.4em; text-indent: 30px; }
	h3 { font-size: 1em; }
	h6 { font-size: 1.1em; font-weight: 400; }
}
.articleList { background: rgb(230, 230, 230); padding: 30px 0;
	.imgArticle { width: 100%; height: 200px; margin-bottom: 10px;
		img { object-fit: cover; height: 100%; width: 100%; }
	}
	a { color: #333; text-decoration: none; }
	h3 { font-size: 1em; }
}
.featureListFeatureLaction {
	li { margin-bottom: 10px; }
	h3 { text-align: center; }
	a { color: #333; text-decoration: none; }
}

/* --- */
.head-banner {
	position: relative;

	.banner-delimiter {
		position: absolute;
		z-index: 2;
    top: 0;
    bottom: 0;

		&.mobile {
			width: 100%;
			top: unset;
			bottom: 5px;
		}

		button {
			i {
				color: #000;
			}

			&.v-btn--active {
				i {
					color: #ed1c24;

					&::after {
						content: " ";
							position: absolute;
							border: solid 1px #ed1c24;
							border-radius: 50%;
							opacity: unset;
							background: unset;
					}
				}
			}
		}
	}

	.banner-arrow {
		bottom: 0;
		// left: 60px;
		left: calc(100vw / 2 - 52px);
		// right: 292px;

		&:nth-of-type(2) {
			// left: 112px;
			left: calc(100vw / 2);
			// right: 240px;
		}
	}

	.banner-carousel {
		height: 26vw; // 100vw;
	}
	@media (min-width: 500px) {
		.banner-carousel {
			height: 26vw; // 500px;
		}
	}
}
.bg-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(237,28,36,1) 0%, rgba(199,37,43,1) 100%);

	.container {
		position: relative;
	}
	&.bg-black-right {
		&::before {
			content: ' ';
			position: absolute;
			top: 0;
			left: 65%;
			bottom: 0;
			right: 0;

			background: rgb(0,0,0);
			background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(16,16,16,1) 100%);
		}

		@media (max-width: 959px) {
			& {
				background: transparent !important;

				&::before {
					display: none;
				}
			}
		}
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(237,28,36,1) 0%, rgba(237,28,36,1) 50%, rgba(157,30,37,1) 50%, rgba(157,30,37,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 25%, rgba(157,30,37,1) 25%, rgba(157,30,37,1) 100%);
	}
}
.bg-dark-grey {
	background-color: #3d3d3d;
}
.property-recommend > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(237,28,36,1) 0%, rgba(237,28,36,1) 50%, rgba(157,30,37,1) 50%, rgba(157,30,37,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(237,28,36,1) 0%, rgba(237,28,36,1) 50%, rgba(157,30,37,1) 50%, rgba(157,30,37,1) 100%);
		position: absolute;
		width: 8%;
		left: -8%;
		top: 0;
		bottom: 0;
	}
}
.services {
	font-size: 1.25rem;

	@media (max-width: 465px) {
		font-size: initial;
	}
	@media (max-width: 385px) {
		font-size: small;
	}
}
.home-cate {
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.home-cate-1 { background-image: url(/images/2.0/icon/home-1.png); }
		&.home-cate-2 { background-image: url(/images/2.0/icon/home-2.png); }
		&.home-cate-3 { background-image: url(/images/2.0/icon/home-3.png); }
		&.home-cate-4 { background-image: url(/images/2.0/icon/home-4.png); }
		&.home-cate-5 { background-image: url(/images/2.0/icon/home-5.png); }
		&.home-cate-6 { background-image: url(/images/2.0/icon/home-6.png); }
	}

	&:hover {
		background-color: #ed1c24 !important;
		color: #fff;

		& .home-cate-logo {
			&.home-cate-1 { background-image: url(/images/2.0/icon/home-1_wh.png); }
			&.home-cate-2 { background-image: url(/images/2.0/icon/home-2_wh.png); }
			&.home-cate-3 { background-image: url(/images/2.0/icon/home-3_wh.png); }
			&.home-cate-4 { background-image: url(/images/2.0/icon/home-4_wh.png); }
			&.home-cate-5 { background-image: url(/images/2.0/icon/home-5_wh.png); }
			&.home-cate-6 { background-image: url(/images/2.0/icon/home-6_wh.png); }
		}
	}
}
.property-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.property-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		@media (max-width: 445px) {
			width: 45px;
		}
		@media (max-width: 400px) {
			width: 30px;
		}

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .property-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
</style>
